var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivation = function SvgActivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1589,
    height: 1548,
    viewBox: "-10 0 1589 1548"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1579 774-839 774v-453H-10V453h750V0ZM66 1019h750v356l651-601-651-602v356H66Zm825 183V943H141V604h750V345l465 429z"
  })));
};
export default SvgActivation;